(function () {
  // Get currency symbol from body attribute
  const currencySymbol = document.body.getAttribute('data-currency') || '$';

  function initModal(modal) {
    toggleModal(modal, true);

    const closeModalOverlay = (event) => {
      if (event.target.classList.contains('js-quick-view-overlay')) {
        toggleModal(modal, false);
        cleanupModalListeners();
      }
    };

    const closeModalEscape = (event) => {
      if (event.key === 'Escape') {
        toggleModal(modal, false);
        cleanupModalListeners();
      }
    };

    const cleanupModalListeners = () => {
      document.removeEventListener('keydown', closeModalEscape);
      document.removeEventListener('click', closeModalOverlay);
    };

    // Add event listeners
    document.addEventListener('keydown', closeModalEscape);
    document.addEventListener('click', closeModalOverlay);

    // Get all the necessary elements
    const variantInputs = modal.querySelectorAll('input[type="radio"][data-option-name]');
    const variantIdInput = modal.querySelector('.js-product-variant-id');
    const priceElement = modal.querySelector('.js-product-price');
    const addToCartButton = modal.querySelector('button[type="submit"]');
    const closeButton = modal.querySelectorAll('.js-quick-view-close');
    const variantsData = JSON.parse(modal.querySelector('[data-selected-variant]').textContent);

    // Create option name mapping
    const optionNameMapping = createOptionNameMapping(variantsData, variantInputs);

    // Initialize quantity selector
    initQuantitySelector(modal);

    // Handle variant option changes
    if (variantInputs.length > 0) {
      variantInputs.forEach((input) => {
        input.addEventListener('change', () =>
          handleVariantChange(
            input,
            modal,
            variantIdInput,
            priceElement,
            variantsData,
            addToCartButton,
            optionNameMapping
          )
        );
      });
    }

    // Close modal when close button is clicked
    if (closeButton) {
      closeButton.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          toggleModal(modal, false);
          cleanupModalListeners();
        });
      });
    }

    // Handle form submission
    const form = modal.querySelector('form');
    if (form) {
      form.addEventListener('submit', (event) => handleAddToCart(event, modal, variantsData, cleanupModalListeners));
    }
  }

  function initQuantitySelector(modal) {
    // Use event delegation for quantity controls
    modal.addEventListener('click', handleQuantityAction);
    modal.addEventListener('input', handleQuantityInput);
  }

  function handleQuantityAction(event) {
    const target = event.target;
    const action = target.getAttribute('data-action');

    if (!action || (action !== 'minus' && action !== 'plus')) return;

    const quantityInput = target.closest('form').querySelector('input[name="quantity"]');
    if (!quantityInput) return;

    const currentValue = parseInt(quantityInput.value);

    if (action === 'minus' && currentValue > 1) {
      quantityInput.value = currentValue - 1;
    } else if (action === 'plus') {
      quantityInput.value = currentValue + 1;
    }
  }

  function handleQuantityInput(event) {
    const target = event.target;

    if (target.name !== 'quantity') return;

    const value = parseInt(target.value);
    if (value < 1) {
      target.value = 1;
    }
  }

  function handleVariantChange(
    selectedInput,
    modal,
    variantIdInput,
    priceElement,
    variantsData,
    addToCartButton,
    optionNameMapping
  ) {
    if (!selectedInput.checked) return;

    // Get all selected options
    const selectedOptions = {};
    const allVariantInputs = modal.querySelectorAll('input[type="radio"][data-option-name]:checked');

    allVariantInputs.forEach((input) => {
      const optionName = input.getAttribute('data-option-name');
      const optionValue = input.getAttribute('data-option-value');
      selectedOptions[optionName] = optionValue;
    });

    // Find the matching variant
    const matchingVariant = findMatchingVariant(variantsData, selectedOptions, optionNameMapping);

    if (matchingVariant) {
      // Update variant ID
      if (variantIdInput) {
        variantIdInput.value = matchingVariant.id;
      }

      // Update price
      if (priceElement) {
        updatePrice(priceElement, matchingVariant);
      }

      // Update button state
      if (addToCartButton) {
        updateAddToCartButton(addToCartButton, matchingVariant);
      }

      // Update selected value text for the changed option
      updateSelectedValueText(selectedInput, modal);
    } else {
      console.error('No matching variant found');
    }
  }

  function updateSelectedValueText(selectedInput, modal) {
    // Find the option selector container for this input
    const optionSelector = selectedInput.closest('.product-option-selector');
    if (optionSelector) {
      const selectedValueSpan = optionSelector.querySelector('.selected-value');
      if (selectedValueSpan) {
        const optionValue = selectedInput.getAttribute('data-option-value');
        selectedValueSpan.textContent = optionValue;
      }
    }
  }

  function createOptionNameMapping(variantsData, variantInputs) {
    // Create a mapping between option names and their positions (option1, option2, option3)
    const mapping = {};
    const optionGroups = {};

    // Group inputs by option name
    variantInputs.forEach((input) => {
      const optionName = input.getAttribute('data-option-name');
      if (!optionGroups[optionName]) {
        optionGroups[optionName] = [];
      }
      optionGroups[optionName].push(input);
    });

    // Determine the order of options based on the first variant
    const firstVariant = variantsData[0];
    if (firstVariant) {
      const optionNames = Object.keys(optionGroups);
      optionNames.forEach((optionName, index) => {
        mapping[optionName] = index + 1; // option1, option2, option3
      });
    }

    return mapping;
  }

  function findMatchingVariant(variantsData, selectedOptions, optionNameMapping) {
    return variantsData.find((variant) => {
      // Check if all selected options match the variant's options
      return Object.keys(selectedOptions).every((optionName) => {
        const selectedValue = selectedOptions[optionName];
        const optionIndex = optionNameMapping[optionName];
        const variantOptionValue = variant[`option${optionIndex}`];
        return selectedValue === variantOptionValue;
      });
    });
  }

  function updatePrice(priceElement, variant) {
    const price = variant.price;
    const compareAtPrice = variant.compare_at_price;

    // Find existing price elements
    const regularPriceSpan = priceElement.querySelector('.price-item--regular');
    const salePriceSpan = priceElement.querySelector('.price-item--sale');

    // Update regular price
    if (regularPriceSpan) {
      regularPriceSpan.textContent = formatMoney(price);
    }

    // Handle compare at price
    if (compareAtPrice && compareAtPrice > price) {
      // Show sale price if it doesn't exist
      if (!salePriceSpan) {
        const newSaleSpan = document.createElement('span');
        newSaleSpan.className = 'price-item price-item--sale';
        newSaleSpan.textContent = formatMoney(compareAtPrice);
        priceElement.appendChild(newSaleSpan);
      } else {
        // Update existing sale price
        salePriceSpan.textContent = formatMoney(compareAtPrice);
      }
    } else {
      // Remove sale price if it exists but shouldn't be shown
      if (salePriceSpan) {
        salePriceSpan.remove();
      }
    }
  }

  function formatMoney(cents) {
    // Use Shopify's money format if available, otherwise fallback
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }

    // Fallback formatting with dynamic currency
    return currencySymbol + (cents / 100).toFixed(2);
  }

  function updateAddToCartButton(button, variant) {
    button.setAttribute('data-available', variant.available);
    button.disabled = !variant.available;
  }

  async function handleAddToCart(event, modal, variantsData, cleanupModalListeners) {
    event.preventDefault();

    const form = event.target;
    const formData = new FormData(form);
    const addToCartButton = form.querySelector('button[type="submit"]');
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');
    const cart = cartDrawer || cartNotification;

    // Disable button during submission
    addToCartButton.disabled = true;

    // Add sections for cart drawer/notification if they exist
    if (cart) {
      const sections = cart.getSectionsToRender().map((section) => section.id);
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (response.ok && !result.status) {
        // Close the modal first
        // toggleModal(modal, false);
        // cleanupModalListeners();

        // Open cart drawer with the new contents
        if (cart) {
          cart.renderContents(result);
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
      } else {
        // Show error message in modal (no auto-close for errors)
        showModalNotification(modal, false, false);
        throw new Error(result.description || 'Failed to add to cart');
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      // Show error message in modal if not already shown
      if (!modal.querySelector('.js-modal-notification[data-active="error"]')) {
        showModalNotification(modal, false, false);
      }
    } finally {
      // Re-enable button and reset to appropriate state
      const variantId = formData.get('id');
      const variant = variantsData.find((v) => v.id.toString() === variantId);
      if (variant) {
        updateAddToCartButton(addToCartButton, variant);
      }
    }
  }

  function showModalNotification(modal, success = true, autoClose = false, cleanupModalListeners = null) {
    // Find or create notification container
    let notificationContainer = modal.querySelector('.js-modal-notification');
    if (notificationContainer) {
      notificationContainer.setAttribute('data-active', success ? 'success' : 'error');
    }

    // Auto-close modal if requested
    if (autoClose) {
      setTimeout(() => {
        toggleModal(modal, false);
        // Reset notification container
        if (notificationContainer) {
          notificationContainer.setAttribute('data-active', 'false');
        }
        if (cleanupModalListeners) {
          cleanupModalListeners();
        }
      }, 2000);
    }
  }

  function toggleModal(modal, open = true) {
    if (open) {
      modal.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
    } else {
      modal.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    }
  }

  // Global event listener for quick view modal variant initialization
  document.addEventListener('quick-rca-quick-view-opened', (event) => {
    // Add a small delay to ensure modal content is fully rendered
    setTimeout(() => {
      initModal(event.detail);
    }, 100);
  });

  // Global click handler for all quick view buttons
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[data-modal]');
    if (!button) return;
    
    event.preventDefault();
    const modalSelector = button.getAttribute('data-modal');
    const modal = document.querySelector(modalSelector);
    
    if (modal) {
      modal.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      document.dispatchEvent(new CustomEvent('quick-rca-quick-view-opened', {
        detail: modal
      }));
    }
  });
})();
